/**
 * JSON 데이터를 파일 형태로 다운로드 할 수 있는 창을 엽니다.
 * @param content
 * @param filename
 * @param contentType
 */
export function exportJSONToFile(
  content: any,
  filename: string,
  contentType?: string,
): void {
  if (!contentType) contentType = 'application/json;charset=utf-8';

  const rawData = new TextEncoder().encode(JSON.stringify(content, null, 2));

  const a = document.createElement('a');
  const blob = new Blob([rawData], { type: contentType });
  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}
